import * as React from 'react';
import { useColorScheme } from '@mui/joy/styles';
import IconButton, { IconButtonProps } from '@mui/joy/IconButton';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeIcon from '@mui/icons-material/LightMode';
import {UserSessionData} from "../../app/userSessionData";
import { useColorScheme as useColorSchemeM} from '@mui/material/styles';

export default function ColorSchemeToggle(props: IconButtonProps) {
    const { onClick, sx, ...other } = props;
    const { mode, setMode } = useColorScheme();
    const uColorSchemeM = useColorSchemeM();
    const [mounted, setMounted] = React.useState(false);
    React.useEffect(() => {
        setMounted(true);
        const colorMode = UserSessionData.getInstance().getColorMode();
        if(colorMode==='dark'||colorMode==='light') {
            setMode(colorMode);
            uColorSchemeM.setMode(colorMode);
        }
    }, []);

    return (
        <IconButton
            disabled={!mounted}
            data-screenshot="toggle-mode"
            size="sm"
            variant="outlined"
            color="neutral"
            {...other}
            onClick={(event) => {
                let colorMode:'light' | 'dark' | 'system'='light';
                if (mode === 'light') {
                    colorMode = 'dark';
                } else {
                    colorMode='light';
                }
                uColorSchemeM.setMode(colorMode);
                setMode(colorMode);
                UserSessionData.getInstance().setColorMode(colorMode)
                onClick?.(event);
            }}
            sx={[
                mode === 'dark'
                    ? { '& > *:first-of-type': { display: 'none' } }
                    : { '& > *:first-of-type': { display: 'initial' } },
                mode === 'light'
                    ? { '& > *:last-child': { display: 'none' } }
                    : { '& > *:last-child': { display: 'initial' } },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        >
            <DarkModeRoundedIcon />
            <LightModeIcon />
        </IconButton>
    );
}
